import {
    ADD_NEW_CUSTOMER_TIER,
    ADD_NEW_CUSTOMER_TYPE,
    ADD_NEW_USER_ROLE, DELETE_PERMISSION_FROM_ROLE, DELETE_USER_FROM_ROLE, DELETE_WIDGET_FROM_ROLE,
    UPDATE_CUSTOMER_TIER, UPDATE_CUSTOMER_TYPE,
    UPDATE_USER_ROLE
} from "@/gql";
import {apolloClient} from '@/apollo'

export const state = {
    loading: false,
    errors: [],
}
export const getters = {
    userSettingsLoading: state => state.loading,
    userSettingsErrors: state => state.errors
}
export const actions = {

    async addNewUserRole({commit}, UserRoleInput){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            await apolloClient.mutate({
                mutation: ADD_NEW_USER_ROLE,
                variables: UserRoleInput
            })
            return true
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async updateUserRole({commit}, roleData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {role}} = await apolloClient.mutate({
                mutation: UPDATE_USER_ROLE,
                variables: roleData,
            })
            return role.role

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async deleteUserFromRole({commit}, roleData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {deleteRoleAssignment}} = await apolloClient.mutate({
                mutation: DELETE_USER_FROM_ROLE,
                variables: roleData,
            })
            return deleteRoleAssignment

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async deletePermissionFromRole({commit}, roleData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {removeRolePermission}} = await apolloClient.mutate({
                mutation: DELETE_PERMISSION_FROM_ROLE,
                variables: roleData,
            })
            return removeRolePermission

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async deleteWidgetFromRole({commit}, roleData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {deleteRoleWidget}} = await apolloClient.mutate({
                mutation: DELETE_WIDGET_FROM_ROLE,
                variables: roleData,
            })
            return deleteRoleWidget

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addNewCustomerTier({commit}, tierData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            await apolloClient.mutate({
                mutation: ADD_NEW_CUSTOMER_TIER,
                variables: tierData
            })
            return true
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async updateCustomerTier({commit}, tierData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {tier}} = await apolloClient.mutate({
                mutation: UPDATE_CUSTOMER_TIER,
                variables: tierData,
            })
            return tier.tier

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addNewCustomerType({commit}, typeData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            await apolloClient.mutate({
                mutation: ADD_NEW_CUSTOMER_TYPE,
                variables: typeData
            })
            return true
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async updateCustomerType({commit}, typeData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {institutionType}} = await apolloClient.mutate({
                mutation: UPDATE_CUSTOMER_TYPE,
                variables: typeData,
            })
            return institutionType.institutionType

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
}
export const mutations = {
    LOADING_TRUE(state){
        state.loading = true
    },
    LOADING_FALSE(state){
        state.loading = false
    },
    SET_ERRORS(state, payload){
        state.errors = payload
    },
    REMOVE_ERRORS(state){
        state.errors = []
    }
}


